var map = {
	"./banner.png": "brcJ",
	"./bar.png": "frcf",
	"./nofind.png": "56Qm",
	"./ptGame-bg-active.png": "gLxD",
	"./ptGame-bg-default.png": "wl+Y",
	"./ptGame1.png": "eYkp",
	"./ptGame2.png": "H4AV",
	"./ptGame3.png": "gZTp",
	"./ptGame4.png": "RWQa",
	"./ptGame5.png": "8rQl",
	"./ptGame6.png": "5G5O",
	"./ptsearch.png": "GI4U"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Lk5P";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ptgames ^\.\/.*\.png$
// module id = Lk5P
// module chunks = 3